export default __webpack_public_path__ + "static/media/manali.f6fb79ee.jpg";